import { render } from "./drawer-advance-detail.vue?vue&type=template&id=63a1ecdf&scoped=true"
import script from "./drawer-advance-detail.vue?vue&type=script&lang=js"
export * from "./drawer-advance-detail.vue?vue&type=script&lang=js"

import "./drawer-advance-detail.vue?vue&type=style&index=0&id=63a1ecdf&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a1ecdf"]])

export default __exports__